import React from "react";
import "./essentiel.css";
import ReactGA from "react-ga4";
import { useHistory, useLocation } from "react-router-dom";


const ONGLETS = ({ activeTab, setActiveTab }) => {
  const history = useHistory();
  const location = useLocation();

  const tabs = [
    { name: "ÉMOLUMENTS D’ACTES", className: "link-actes", event: "click_essentiel_emoluments_actes" },
    { name: "ÉMOLUMENTS DE FORMALITÉS", className: "link-form", event: "click_essentiel_emoluments_formalites" },
    { name: "Fiscalité", className: "link-fiscalite", event: "click_essentiel_fiscalite" },
    { name: "Droits fixes (rappel)", className: "link-fixes", event: "click_essentiel_droits_fixes" },
    { name: "Débours", className: "link-fiches", event: "click_essentiel_debours" },
  ];

  const handleClick = () => {
    const baseUrl = "/" + location.pathname.split("/")[1]; 
    history.push(baseUrl);
  };

return (
    <nav className="onglets_essentiel">
      <ul className="ul_essentiel">
        {tabs.map((tab) => (
          <li
            key={tab.name}
            className={`li_essentiel ${tab.className} ${activeTab === tab.name ? "active" : "inactive"}`}
            onClick={() => {
              if (window.gtag) {
                window.gtag("event", tab.event, {
                  event_category: "Essentiel",
                  event_label: tab.name,
                });
              }
              handleClick();
              setActiveTab(tab.name);
            }}
          >
            <span>{tab.name}</span>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ONGLETS;
